import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { school, formatApiError } from "../../lib/api";

const COPY = {
  teacher: {
    title: "Teacher sign-in code",
    help: "For safety, students can't sign in on their own. When a student logs in, you type your 4-digit teacher code too.",
  },
  parent: {
    title: "Parent sign-in code (your Kids Mode PIN)",
    help: "For safety, your children can't sign in on their own. When a child logs in, you type the same 4-digit PIN you use for Kids Mode.",
  },
};

export const GuardianCodeCard = ({ kind = "teacher" }) => {
  const { user, refreshUser } = useAuth();
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const isSet = kind === "parent" ? user?.kids_pin_set : user?.guardian_code_set;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await school.guardianCode(code, password || undefined, kind);
      toast.success(kind === "parent" ? "Kids Mode PIN saved" : "Teacher code saved");
      setCode("");
      setPassword("");
      refreshUser();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };
  return (
    <form onSubmit={save} data-testid={`guardian-code-card-${kind}`} className="what-plan space-y-3">
      <p className="font-display font-semibold text-white flex items-center gap-2"><KeyRound size={16} /> {COPY[kind].title}</p>
      <p className="text-xs text-slate-400">
        {COPY[kind].help}{" "}
        <span data-testid={`guardian-code-status-${kind}`} className={isSet ? "text-[#D4FF3A]" : "text-[#FBBF24]"}>{isSet ? "A code is set." : "No code yet, so they can't sign in."}</span>
      </p>
      <div className="flex flex-wrap gap-2">
        <input data-testid={`guardian-code-input-${kind}`} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, kind === "parent" ? 6 : 4))} inputMode="numeric" placeholder={kind === "parent" ? "4–6 digit PIN" : "4-digit code"} className="what-input !w-44 tracking-[0.2em] font-mono" />
        {user?.has_password && <input data-testid={`guardian-code-password-${kind}`} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Your account password" className="what-input !w-56" />}
        <button data-testid={`guardian-code-save-${kind}`} disabled={code.length < 4 || busy} className="what-btn-primary disabled:opacity-40">{busy && <Loader2 size={14} className="animate-spin" />} {isSet ? "Change code" : "Set code"}</button>
      </div>
    </form>
  );
};
